import Vue from "vue";
import Buefy from "buefy";

import ProductList from "./App.vue";
import Product from "./components/Product.vue"
import ListAside from "./components/ListAside.vue"


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(ProductList)
Vue.use(Product)
Vue.use(ListAside)

if(document.getElementById("productListApp")){
    new Vue({
        render:h=>h(
            ProductList,{
                props:{
                    page:document.getElementById("productListApp").getAttribute("page"),
                    ordering:document.getElementById("productListApp").getAttribute("ordering"),
                    category:document.getElementById("productListApp").getAttribute("category"),
                    subcategory:document.getElementById("productListApp").getAttribute("subcategory"),
                    listUrl:document.getElementById("productListApp").getAttribute("listUrl"),
                    primaryColor:document.getElementById("productListApp").getAttribute("primary-color"),
                    blackText:document.getElementById("productListApp").getAttribute("black-text"),
                    listTemplate:document.getElementById("productListApp").getAttribute("listTemplate"),
                    categoriesUrl:document.getElementById("productListApp").getAttribute("categories"),
                    filterListUrl:document.getElementById("productListApp").getAttribute("filter-list"),
                    selectedFilterList:document.getElementById("productListApp").getAttribute("selected-filter-list"),
                    cartItemUrl:document.getElementById("productListApp").getAttribute("cartItemUrl"),
                    addFromCatalog:document.getElementById("productListApp").getAttribute("add_from_catalog")
                }
            }
        )
    }).$mount("#productListApp")
}